export default __webpack_public_path__ + "static/media/scsit.2e2e4704.jpg";